import React from "react";
import { FeatherAlertCircle } from "@subframe/core";
import { CustomerExpenseRefundCategoryDetails } from "../../services/api";

interface CustomerExpenseRefundViewContentProps {
  details: CustomerExpenseRefundCategoryDetails | null;
  isLoading?: boolean;
}

const CustomerExpenseRefundViewContent: React.FC<
  CustomerExpenseRefundViewContentProps
> = ({ details, isLoading = false }) => {
  if (isLoading) {
    return (
      <div className="flex w-full items-center justify-center rounded-md border border-dashed border-neutral-border bg-neutral-50 px-6 py-10 text-body text-subtext-color">
        Loading expense refund details...
      </div>
    );
  }

  if (!details) {
    return (
      <div className="flex w-full flex-col items-center gap-2 rounded-md border border-dashed border-neutral-border bg-neutral-50 px-6 py-10 text-center text-body text-subtext-color">
        <FeatherAlertCircle className="text-neutral-400" />
        <span>
          Expense refund details are not available for this transaction.
        </span>
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col gap-4 rounded-md border border-solid border-neutral-border bg-neutral-50 px-6 py-6">
      <div className="flex flex-col gap-1">
        <span className="text-heading-3 font-heading-3 text-default-font">
          Customer Expense Refund
        </span>
      </div>

      <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-2">
        <div className="flex flex-col rounded-md border border-dashed border-neutral-border px-4 py-3">
          <span className="text-caption text-subtext-color">From Account</span>
          <span className="text-heading-4 font-heading-4 text-default-font">
            {details.from_account_name}
          </span>
        </div>
        <div className="flex flex-col rounded-md border border-dashed border-neutral-border px-4 py-3">
          <span className="text-caption text-subtext-color">Date</span>
          <span className="text-heading-4 font-heading-4 text-default-font">
            {details.date ? new Date(details.date).toLocaleDateString() : "—"}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CustomerExpenseRefundViewContent;
